import { SlotId, ContentUnitId } from 'services/adition'
import config from 'config'

type SlotIdMap = {
  [slotId: string]: ContentUnitId
}

const slotIdContentUnitIdMap: SlotIdMap = {
  'game-ranking-slot': 4176479,
  'game-timeline-slot': 4176480,
  'game-my-team-slot': 4176481,
  'game-history-slot-0': 4176478,
  'game-history-slot-1': 4176478,
  'game-history-slot-2': 4176478,
  'leaderboard-global-slot-0': 4176571,
  'leaderboard-global-slot-1': 4176571,
  'leaderboard-global-slot-2': 4176571,
  'leaderboard-friends-slot-0': 4176476,
  'leaderboard-friends-slot-1': 4176476,
  'leaderboard-friends-slot-2': 4176476,
  'leaderboard-score-slot-0': 4176477,
  'leaderboard-score-slot-1': 4176477,
  'leaderboard-score-slot-2': 4176477,
}

export const getContentUnitId = (slotId: SlotId): ContentUnitId | null =>
  slotIdContentUnitIdMap[slotId] || null

export const areAdsDisabledByEnv = () => config.IS_ADITION_DISABLED

export default slotIdContentUnitIdMap
try {
    // @ts-ignore
    getContentUnitId.displayName = "getContentUnitId";
    // @ts-ignore
    getContentUnitId.__docgenInfo = { "description": "", "displayName": "getContentUnitId", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/config/adSlots.ts#getContentUnitId"] = { docgenInfo: getContentUnitId.__docgenInfo, name: "getContentUnitId", path: "src/config/adSlots.ts#getContentUnitId" };
}
catch (__react_docgen_typescript_loader_error) { }